// Generated by ReScript, PLEASE EDIT WITH CARE

import * as EventTracker from "../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";

function publishEvent(data, country) {
  var countryLabel = CountryConfig.countryToString(country).toUpperCase();
  var match = data.category;
  var category;
  switch (match) {
    case /* PlaceOrder */0 :
        category = "Customer Profile Page " + countryLabel;
        break;
    case /* PickUpDrop */1 :
        category = "Place Order PickUp Drop " + countryLabel;
        break;
    case /* VehicleSelection */2 :
        category = "Place Order Vehicle Selection " + countryLabel;
        break;
    case /* ConfirmOrder */3 :
        category = "Place Order Confirm Order " + countryLabel;
        break;
    
  }
  var action = data.action + " " + countryLabel;
  return EventTracker.publishEvent({
              category: category,
              action: action,
              label: data.label,
              value: data.value,
              nonInteraction: data.nonInteraction
            });
}

export {
  publishEvent ,
  
}
/* EventTracker Not a pure module */
